import React from 'react';

// Import your SVGs
import cfye1 from '../../assets/cfye-images/cfye1.svg';
import cfye2 from '../../assets/cfye-images/cfye2.svg';
import cfye3 from '../../assets/cfye-images/cfye3.svg';
import cfye4 from '../../assets/cfye-images/cfye4.svg';
import cfye5 from '../../assets/cfye-images/cfye5.svg';
import cfye6 from '../../assets/cfye-images/cfye6.svg';

export default function CfyeHeader() {
  const images = [cfye1, cfye2, cfye3, cfye4, cfye5, cfye6];

  return (
    <header className="bg-white text-text-color overflow-hidden">
      {/* HEADER TEXT SECTION */}
      <div className="flex flex-col items-center justify-center w-full mx-auto px-4 sm:px-6 md:px-8 py-10 sm:py-14 lg:py-20 xl:py-24">
        <div className="text-center">
          <h1 className="max-w-xs sm:max-w-md md:max-w-3xl lg:max-w-5xl mx-auto text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-normal pt-4">
            Tackling Youth Unemployment and Creating{' '}
            <span className="font-serif italic text-primary font-semibold">
              Livelihood for 3600{' '}
            </span>
            Women{' '}
            <span className="font-serif italic text-secondary font-semibold">
              Under 35 Years Old
            </span>
          </h1>

          <p className="max-w-sm sm:max-w-md md:max-w-3xl lg:max-w-4xl mx-auto text-sm sm:text-base md:text-lg leading-relaxed pt-6 text-gray-700">
            In partnership with the Challenge Fund for Youth Employment (CFYE),
            Shecluded’s Dream to Business Incubator Program empowers young women
            across Nigeria to innovate, build sustainable livelihoods, and
            transform their dreams into thriving businesses. Together, we’re
            creating inclusive opportunities for women-led enterprises to grow,
            fueling confidence, economic resilience, and lasting impact.
          </p>
        </div>

        <div className="mt-8 sm:mt-10">
          <a
            href="https://fundforyouthemployment.nl/"
            className="inline-flex items-center justify-center font-semibold rounded-full px-6 sm:px-8 py-2 sm:py-3 text-sm sm:text-base border border-black hover:bg-black hover:text-white transition-colors duration-300"
          >
            Learn more
          </a>
        </div>
      </div>

      {/* INFINITE SCROLLING CAROUSEL */}
      <div className="relative w-full overflow-hidden py-10">
        <div className="flex w-[200%] animate-infinite-scroll">
          {[...images, ...images].map((img, index) => (
            <div
              key={index}
              className="flex-shrink-0 flex items-center justify-center 
                   px-[2px] sm:px-[4px]" // tight but scales slightly on larger screens
            >
              <img
                src={img}
                alt={`cfye-${index}`}
                className="
            object-contain
            h-[180px]   // mobile
            sm:h-[220px] // small screens
            md:h-[280px] // tablets
            lg:h-[320px] // laptops
            xl:h-[365px] // large screens
            w-auto
          "
              />
            </div>
          ))}
        </div>
      </div>
    </header>
  );
}
